import { render, staticRenderFns } from "./UploadAuthorization.vue?vue&type=template&id=84e2ab14&scoped=true"
import script from "./UploadAuthorization.vue?vue&type=script&lang=js"
export * from "./UploadAuthorization.vue?vue&type=script&lang=js"
import style0 from "./UploadAuthorization.vue?vue&type=style&index=0&id=84e2ab14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e2ab14",
  null
  
)

export default component.exports